import React, { useEffect, useRef, useState } from "react";
import "../styles/HeroSlider.css"
import Image from "./Image/Image";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { StyledInstance } from "styled-components";
import { useNavigate } from "react-router-dom";

interface Slide {
    mediaUrl: string;
    collectionUrl: string;
    name: string;
}

interface HeroSliderProps {
    slides: string[];
}



const HeroSlider: React.FC = () => {
    const config = useSelector((state: RootState) => state.siteConfig);
    
    const slides: Slide[] = config.homePageImageSlider;

    const [imagesLoaded, setImagesLoaded] = useState<boolean>(false);
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const intervalRef = useRef<number | null>(null);
    const navigate = useNavigate();

    // Handle when all images are loaded
    const handleAllImagesLoaded = () => {
        setImagesLoaded(true);
    };

    // Start the slider interval
    const startSlider = () => {
        intervalRef.current = window.setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
        }, 3000); // Adjust time as needed (e.g., 3 seconds)
    };

    // Clear the slider interval
    const stopSlider = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    const handleNavigateToSlide = (url: string) => {
        navigate('products?collections='+url);
    }


    useEffect(() => {
        if (imagesLoaded) {
            startSlider(); // Start automatic sliding after images are loaded
        }
        return () => stopSlider(); // Cleanup interval on component unmount
    }, [imagesLoaded]);

    return (
        <section className="hero is-large is-fullheight-mobile" id="hero-slider">
            <div className="hero-body">
                <div className="container has-text-centered">
                    <h1 className="title" id="slider-title">
                        {/* Slide 1 */}
                    </h1>
                    <h2 className="subtitle" id="slider-subtitle">
                        {/* Welcome to the first slide! */}
                    </h2>
                    {/* <button className="button is-primary">Next Slide</button> */}
                </div>

                {/* Single skeleton overlay */}
                <div className={`slider-images ${imagesLoaded ? "images-loaded" : ""} `}>
                    {!imagesLoaded && <div className="skeleton-overlay"></div>}
                    {slides.map((slider, index) => (
                        <Image
                            src={slider.mediaUrl}
                            key={index}
                            className={`slide ${index === currentIndex ? "active" : ""}`}
                            onClick={() => handleNavigateToSlide(slider.collectionUrl)}
                            alt={slider.name}
                            loading="lazy"
                            onImageLoad={index === 0 ? handleAllImagesLoaded : undefined} // Trigger on the last image
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HeroSlider;